import { useTranslation } from "react-i18next";

import { Modal } from "@/components";
import { ButtonColor } from "@/components/Button/types";
import { CompanySelection } from "@/components/CompanyBlacklistToggle/companyBlacklist";
import { CompanyBlacklistToggle } from "@/components/CompanyBlacklistToggle/CompanyBlacklistToggle";
import { useSingleFlight } from "@/utils/useSingleFlight";

interface UnassignedBlacklistModalProps {
	/** One lead was picked from its row's menu rather than a selection. */
	pickedFromRow: boolean;
	/** How many leads the selection covers, all of whom are moved to the Blacklist. */
	selectedCount: number;
	/** The companies "also blacklist the company" would block. */
	selection: CompanySelection;
	addCompany: boolean;
	onToggleCompany: (value: boolean) => void;
	onClose: () => void;
	onConfirm: () => Promise<void>;
}

/**
 * The list table's "Add to Blacklist" confirmation. Confirming runs once however often it is
 * clicked: a double click wrote the company entry twice (PREC-4425).
 */
export const UnassignedBlacklistModal = ({
	pickedFromRow,
	selectedCount,
	selection,
	addCompany,
	onToggleCompany,
	onClose,
	onConfirm,
}: UnassignedBlacklistModalProps) => {
	const { t } = useTranslation();
	const confirm = useSingleFlight();

	return (
		<Modal
			isOpened
			handleClose={onClose}
			handleSave={() => confirm.run(onConfirm)}
			isLoading={confirm.isRunning}
			size="xs"
			submitButtonColor={ButtonColor.DANGER}
			submitButtonText={t("inbox.toBlackList")}
			title={t("inbox.addingToBlacklist")}
		>
			{pickedFromRow
				? t("inbox.addingToBlacklistConfirmationMessage")
				: t("blacklist.confirmSelected", { count: selectedCount })}

			<CompanyBlacklistToggle
				isChecked={addCompany}
				selection={selection}
				onChange={onToggleCompany}
			/>
		</Modal>
	);
};
